import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

import { CatalogDetails } from './details/catalog-details.model';

@Injectable()
export class CatalogService {

    context = this;

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    delete(details: any): Observable<CatalogDetails> {
            let url = this.configService.get('server').url + this.configService.get('endpoints').agora.catalogs.delete.api;
            return this.requestService.post(url, details);
    }

    getCatalogDetails(id: string): Observable<CatalogDetails> {
            let url = this.configService.get('server').url + this.configService.get('endpoints').agora.catalogs.details.api + '/' + id;
            return this.requestService.get(url)
                .map(_ => <CatalogDetails>_['data']);
    }

    getDomainDict(params?: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domainList.api;
        return this.requestService.get(url, params);
    }

    getBuyerDomainDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domainListBuyer.api;
        return this.requestService.get(url);
    }

    getSellerDomainDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domainListSeller.api;
        return this.requestService.get(url);
    }



    getDetailsFields(domainSpecific: boolean) {
        let response = [];
        response.push(
            {
                key: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                key: 'code',
                label: 'Code',
                type: 'text'
            },
            {
                key: 'keywords',
                label: 'Keywords',
                type: 'list'
            },
            {
                key: (data) => data.domainSpecific ? (data.lmsCatalog ? 'LMS Catalog' : 'Domain Specific') : 'Marketplace',
                label: 'Catalog Type',
                type: 'text'
            },
            {
                key: 'online',
                label: 'Online',
                type: 'boolean'
            });
        if (domainSpecific) {
            response.push(
                 {
                    key: 'sellerDomains',
                    label: 'Available for Publisher Domains',
                    type: 'list',
                    getter: (item) => item.name
                }, {
                    key: 'buyerDomains',
                    label: 'Available for Subscriber Domains',
                    type: 'list',
                    getter: (item) => item.name
                });
        }
        response.push({
            key: 'catalogSvg',
            label: 'Catalog Svg',
            type: 'textarea'
        })
        return response;
    }

    add(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.catalogs.add.api;
        return this.requestService.post(url, details);
    }

    edit(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.catalogs.edit.api;
        return this.requestService.post(url, details);
    }

    keywordsSource = (request: any, response: any) => {
        const url = this.configService.get('server').url +
            this.configService.get('endpoints').agora.keywords.dictionary.api + '?filter=' + request['term'];

        return this.requestService.get(url)
            .map(_ => _['data'])
            .map(_ => {
                let result = [];
                _.forEach(element => {
                    result.push(element.key);
                });

                return result;
            })
            .subscribe(
                res => response(res)
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/catalogs/catalog.service.ts